import { defineMessages } from "../define";

/** Billing page (invoice preview). The PDF invoice itself is Czech only (billing/invoice-generator). */
export default defineMessages({
  en: {
    "billing.title": "Billing",
    "billing.description":
      "Generate the monthly invoice for operating the pizza checker, based on the number of captured photos.",
    // period and branches
    "billing.periodTitle": "Period and branches",
    "billing.periodDescription":
      "Pick the month and the branches to bill. With no branch selected, all branches are included.",
    "billing.month": "Month",
    "billing.branches": "Branches",
    "billing.branchesPlaceholder": "Select branches (optional)",
    // invoice preview
    "billing.previewTitle": "Invoice preview for {period}",
    "billing.previewDescription":
      "Review the invoice lines before downloading. The invoice number is assigned when the invoice is generated.",
    "billing.nextInvoiceNumber": "Next invoice number: {number}",
    "billing.downloadInvoice": "Download invoice (PDF)",
    "billing.columnBranch": "Branch",
    "billing.columnCaptures": "Captured photos",
    "billing.columnUnitPrice": "Unit price (CZK)",
    "billing.columnSubtotal": "Subtotal (CZK)",
    "billing.unitPieces": "pcs",
    "billing.total": "Total",
    "billing.noBranches": "No branches to invoice.",
    "billing.vatNote": "Prices exclude {rate} VAT. The VAT and the final total are calculated in the invoice.",
    "billing.loadFailed": "Could not load the capture counts.",
    "billing.loadFailedReason": "Could not load the capture counts: {reason}",
  },
  cs: {
    "billing.title": "Fakturace",
    "billing.description":
      "Vygenerujte měsíční fakturu za provoz pizza checkeru podle počtu pořízených fotek.",
    // period and branches
    "billing.periodTitle": "Období a pobočky",
    "billing.periodDescription":
      "Vyberte měsíc a pobočky, které chcete fakturovat. Bez výběru poboček budou zahrnuty všechny.",
    "billing.month": "Měsíc",
    "billing.branches": "Pobočky",
    "billing.branchesPlaceholder": "Vyberte pobočky (volitelné)",
    // invoice preview
    "billing.previewTitle": "Náhled faktury za {period}",
    "billing.previewDescription":
      "Před stažením zkontrolujte řádky faktury. Číslo faktury se přidělí při jejím vygenerování.",
    "billing.nextInvoiceNumber": "Další číslo faktury: {number}",
    "billing.downloadInvoice": "Stáhnout fakturu (PDF)",
    "billing.columnBranch": "Pobočka",
    "billing.columnCaptures": "Pořízené fotky",
    "billing.columnUnitPrice": "Jednotková cena (Kč)",
    "billing.columnSubtotal": "Mezisoučet (Kč)",
    "billing.unitPieces": "ks",
    "billing.total": "Celkem",
    "billing.noBranches": "Žádné pobočky k fakturaci.",
    "billing.vatNote": "Uvedené ceny jsou bez DPH {rate}. DPH a konečná částka se dopočítají ve faktuře.",
    "billing.loadFailed": "Počty pořízených fotek se nepodařilo načíst.",
    "billing.loadFailedReason": "Počty pořízených fotek se nepodařilo načíst: {reason}",
  },
});
